export const emailRegExp = /^[\w.%+-]+@[A-Z\d.-]+\.[A-Z]{2,}$/i;
